"use client";

import React from "react";
import Image from "next/image";
import Link from "next/link";

const galleryImages = [
  {
    src: "/images/Side-by-side-comparison-of-a-young-man-before-and-after-invisalign-treatment-showing-improved-teeth-alignment.webp",
    alt: "Side-by-side-comparison-of-a-young-man-before-and-after-invisalign-treatment-showing-improved-teeth-alignment",
  },
  {
    src: "/images/Before-and-after-showing-a-young-woman-smiling-with-straighter-teeth-in-side-by-side-photos-against-a-neutral-background.webp",
    alt: "Before-and-after-showing-a-young-woman-smiling-with-straighter-teeth-in-side-by-side-photos-against-a-neutral-background",
  },
  {
    src: "/images/Invisalign-before-and-after-showing-a-woman-with-improved-tooth-alignment-straighter-smile-and-healthier-teeth-after-invisalign-treatment.webp",
    alt: "Invisalign-before-and-after-showing-a-woman-with-improved-tooth-alignment-straighter-smile-and-healthier-teeth-after-invisalign-treatment",
  },
  {
    src: "/images/Before-and-after-showing-a-smiling-man-with-straighter-teeth-in-two-side-by-side-photos-wearing-different-colored-shirts-against-a-white-background.webp",
    alt: "Before-and-after-showing-a-smiling-man-with-straighter-teeth-in-two-side-by-side-photos-wearing-different-colored-shirts-against-a-white-background",
  },
  {
    src: "/images/Side-by-side-comparison-of-a-woman-before-and-after-invisalign-showing-straighter-teeth-and-improved-smile.webp",
    alt: "Side-by-side-comparison-of-a-woman-before-and-after-invisalign-showing-straighter-teeth-and-improved-smile",
  },
  {
    src: "/images/Side-by-side-comparison-of-a-woman-before-and-after-invisalign-treatment-showing-improved-teeth-alignment-and-brighter-smile.webp",
    alt: "Side-by-side-comparison-of-a-woman-before-and-after-invisalign-treatment-showing-improved-teeth-alignment-and-brighter-smile",
  },
];

const BeforeAfterGallery: React.FC = () => {
  return (
    <section className="w-full py-6 sm:py-8 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
        <h2
          className="
            text-2xl sm:text-3xl font-semibold text-gray-800 text-center
            pb-6 after:content-[''] after:block after:w-[200px] after:h-[3px] after:mx-auto after:mt-2
            after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]
          "
        >
          Invisalign Before and After Photos
        </h2>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
          If you&apos;re wondering whether Invisalign really works, the
          following before and after Invisalign photos speak for themselves! At
          Smile4Me, we provide custom treatment plans that deliver real results
          for our patients.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 pt-2">
          {galleryImages.map((img, i) => (
            <div
              key={i}
              className="relative w-full h-[220px] sm:h-[260px] md:h-[300px] rounded-lg overflow-hidden shadow-lg"
            >
              <Image
                src={img.src}
                alt={img.alt}
                fill
                className="object-cover"
                sizes="(max-width: 640px) 100vw, 50vw"
              />
            </div>
          ))}
        </div>

        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          Want to see more? Visit{" "}
          <Link
            href="/our-office/"
            className="inline-block bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] bg-clip-text text-transparent hover:underline transition-all duration-300 ease-in-out"
          >
            our Astoria office
          </Link>{" "}
          to view additional photos and get a digital preview of your own
          smile transformation.
        </p>
      </div>
    </section>
  );
};

export default BeforeAfterGallery;
